import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import { AuthTokenPage } from './pages/AuthTokenPage';

export const authRoutes: RouteObject[] = [
  {
    path: '/auth',
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <Navigate to='sso' replace />,
      },
      {
        path: 'sso',
        element: <AuthTokenPage />,
      },
    ],
  },
];
